import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';
// styles
import {
  AccordionStyled,
  BulletedListStyled,
  TypographyStyled,
  DivStyledBulletedListContainerDesktop,
  DivStyledBulletedListContainerMobile,
  SectionContainerStyled,
} from './styles';

export default () => {
  const theme = useContext(ThemeContext);
  const mediumUp = theme.mediumUp();

  const getBulletedList = () => {
    return (
      <BulletedListStyled
        disableBottomPadding
        bulletType='checkmark'
        bulletedListData={[
          {
            bulletText: (<>
              <TypographyStyled
                component='span'
                variant='h5'>
                5M&#43;
              </TypographyStyled> people we&#39;re proud to call clients
            </>
            ),
          },
          {
            bulletText: (
              <>
                <TypographyStyled
                  component='span'
                  variant='h5'>
                  8,000&#43;
                </TypographyStyled> financial advisors and professionals we&#39;re honored to have on our team
              </>
            ),
          },
          {
            bulletText: (
              <>
                <TypographyStyled
                  component='span'
                  variant='h5'>
                  97&#37;
                </TypographyStyled> of our clients stay with us year over year<sup>6</sup>
              </>
            ),
          },
          {
            bulletText: (
              <>
                <TypographyStyled
                  component='span'
                  variant='h5'>
                  Top 5 ranked investment service
                </TypographyStyled>&#8212;We&#39;re one of the top U.S. Independent Investment Broker&#45;Dealers<sup>7</sup>
              </>
            ),
          },
        ]} />
    );
  };
  return (
    <SectionContainerStyled
      id='who-we-are-custom-accolades'
      backgroundVariant='lightB'
      themeType='lightTheme'>
      <Row>
        <Col>
          {mediumUp ? (
            <DivStyledBulletedListContainerDesktop>
              <Typography
                component='h2'
                variant='h3'>
                Just a few numbers we&#39;d like to share with you:
              </Typography>
              {getBulletedList()}
            </DivStyledBulletedListContainerDesktop>
          ) : (
            <DivStyledBulletedListContainerMobile>
              <AccordionStyled
                id='who-we-are-custom-accolades-accordion'
                variant='secondary'
                toggleOpenIcon={PlusSignFillIcon}
                toggleCloseIcon={MinusSignFillIcon}
                items={[
                  {
                    id: 'who-we-are-custom-accolades-numbers-we-like-to-share',
                    title: <>Just a few numbers we&#39;d like to share with you:</>,
                    contentAs: 'div',
                    content: (
                      <>
                        {getBulletedList()}
                      </>
                    ),
                  },
                ]}
              />
            </DivStyledBulletedListContainerMobile>
          )}
        </Col>
      </Row>
    </SectionContainerStyled>
  );
};
